import PropTypes from 'prop-types';

const SeverErrorIllustration = ({ className }) => {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 480 360"
        className="w-full h-full"
      >
        <defs>
          <linearGradient id="BG" x1="19.496%" x2="77.479%" y1="71.822%" y2="16.69%">
            <stop offset="0%" stopColor="#0CA37F" />
            <stop offset="100%" stopColor="#1C7F66" />
          </linearGradient>
        </defs>
        <path
          fill="url(#BG)"
          fillRule="nonzero"
          d="M0 198.78c0 41.458 14.945 79.236 39.539 107.786 28.214 32.765 69.128 53.365 114.734 53.434a148.44 148.44 0 0056.495-11.036c9.051-3.699 19.182-3.274 27.948 1.107a75.779 75.779 0 0033.957 8.01c5.023 0 9.942-.494 14.7-1.433 13.58-2.67 25.94-8.99 36.09-17.94 6.378-5.627 14.547-8.456 22.897-8.446h.142c27.589 0 53.215-8.732 74.492-23.696 19.021-13.36 34.554-31.696 44.904-53.224C474.92 234.58 480 213.388 480 190.958c0-76.93-59.774-139.305-133.498-139.305-7.516 0-14.88.663-22.063 1.899C305.418 21.42 271.355 0 232.499 0a103.651 103.651 0 00-45.88 10.661c-13.24 6.487-25.011 15.705-34.64 26.939-30.63-17.566-65.14-27.516-101.833-27.516C22.498 10.084 0 32.928 0 61.379v137.401z"
          opacity="0.2"
        />
        
        {/* Server Error Illustration */}
        <g transform="translate(120, 80)">
          {/* Server */}
          <rect x="0" y="0" width="240" height="200" rx="10" fill="#0CA37F" opacity="0.1" />
          <rect x="20" y="20" width="200" height="160" rx="8" fill="#0CA37F" opacity="0.2" />
          
          {/* Server lights */}
          <circle cx="40" cy="50" r="6" fill="#FF4842" />
          <circle cx="40" cy="80" r="6" fill="#FFAB00" />
          <circle cx="40" cy="110" r="6" fill="#54D62C" />
          
          {/* Server lines */}
          <rect x="60" y="50" width="140" height="2" fill="#0CA37F" opacity="0.4" />
          <rect x="60" y="80" width="140" height="2" fill="#0CA37F" opacity="0.4" />
          <rect x="60" y="110" width="140" height="2" fill="#0CA37F" opacity="0.4" />
          
          {/* Error symbol */}
          <circle cx="200" cy="40" r="20" fill="#FF4842" opacity="0.8" />
          <rect x="198" y="30" width="4" height="12" fill="white" />
          <circle cx="200" cy="48" r="2" fill="white" />
        </g>
        
        {/* Lightning bolts */}
        <path d="M100 120l15 30h-10l10 25l-20-35h12l-7-20z" fill="#FFAB00" />
        <path d="M380 140l15 30h-10l10 25l-20-35h12l-7-20z" fill="#FFAB00" />
        
        {/* 500 Text */}
        <g fill="#0CA37F" fillRule="nonzero" transform="translate(180, 240)">
          <text x="0" y="40" fontSize="40" fontWeight="bold">500</text>
        </g>
      </svg>
    </div>
  );
};

SeverErrorIllustration.propTypes = {
  className: PropTypes.string
};

export default SeverErrorIllustration;
